import React, { useEffect, useState } from 'react';

// Shows the promo templates assigned to the current pricelist (plus any
// unassigned "shared library" templates), each with a thumbnail card. The
// list endpoint returns thumbnail_url from the first frame's uploaded
// background — templates without one show a placeholder tile.
const PromotionalImages = ({ packageId }) => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!packageId) { setTemplates([]); return; }
    setLoading(true);
    setError(null);
    fetch(`/admin/promo_image_templates/list?package_id=${packageId}`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`))))
      .then((data) => setTemplates(Array.isArray(data) ? data : []))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [packageId]);

  return (
    <div style={{ margin: '4px 0 16px', padding: '10px 12px', background: '#f5f5f5', borderRadius: 4, border: '1px solid #e0e0e0' }}>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, marginBottom: 8 }}>
        <div style={{ fontSize: 12, fontWeight: 600, color: '#555' }}>Promotional Images</div>
        <div style={{ fontSize: 10, color: '#999' }}>
          Templates assigned to this pricelist + shared library templates
        </div>
      </div>

      {loading && <div style={{ fontSize: 11, color: '#999' }}>Loading…</div>}
      {error && <div style={{ fontSize: 11, color: '#c62828' }}>Failed to load: {error}</div>}
      {!loading && !error && templates.length === 0 && (
        <div style={{ fontSize: 11, color: '#999' }}>
          No promotional images yet. Create one in the Promotional Images tab.
        </div>
      )}

      {templates.length > 0 && (
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
          {templates.map((t) => {
            const isShared = t.package_id == null;
            return (
              <div
                key={t.id}
                title={`${t.name} — ${t.output_format.toUpperCase()} • ${t.frame_count} frame${t.frame_count === 1 ? '' : 's'} • ${t.width}×${t.height}${isShared ? ' • shared library' : ''}`}
                style={{
                  width: 120, background: '#fff', border: '1px solid #ddd', borderRadius: 4,
                  overflow: 'hidden', display: 'flex', flexDirection: 'column',
                }}
              >
                <div
                  style={{
                    width: 120, height: 90,
                    background: t.thumbnail_url
                      ? `url(${t.thumbnail_url}) center/cover no-repeat`
                      : 'linear-gradient(135deg, #eee 0%, #ddd 100%)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                  }}
                >
                  {!t.thumbnail_url && (
                    <div style={{ fontSize: 10, color: '#888', textAlign: 'center', padding: '0 6px' }}>
                      No background<br />uploaded yet
                    </div>
                  )}
                </div>
                <div style={{ padding: 6, borderTop: '1px solid #eee' }}>
                  <div style={{ fontSize: 11, fontWeight: 600, color: '#333', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {t.name}
                  </div>
                  <div style={{ fontSize: 9, color: '#999', marginTop: 2, display: 'flex', gap: 4 }}>
                    <span>{t.output_format === 'gif' ? 'GIF' : 'STATIC'}</span>
                    <span>·</span>
                    <span>{t.frame_count}f</span>
                    {isShared && (
                      <>
                        <span>·</span>
                        <span style={{ color: '#1976d2' }}>shared</span>
                      </>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default PromotionalImages;
